module.exports = __webpack_public_path__ + "img/piping_width.09476add.png";